<template>
  <div class="login-button-container">
    <vf-button :variant="buttonVariants.secondary" @click="openLoginTab">{{
      $t('iframeLoginView.logIn')
    }}</vf-button>
  </div>
</template>

<script lang="ts">
  import { endpointsList } from '@/helpers';
  import { IFRAME_TARGET_URL_LOCAL_STORAGE_KEY } from '@/interfaces';
  import axios from 'axios';
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'IframeLoginView',
    mounted() {
      this.pollAuthentication();
    },
    methods: {
      openLoginTab() {
        const loginUrl = `${document.location.origin}/api/oauth/login?popup=true`;
        window.open(
          loginUrl,
          'login',
          'width=520,height=640,menubar=no,toolbar=no,location=yes,resizable=yes,scrollbars=yes',
        );
      },
      async pollAuthentication() {
        while (true) {
          const isAuthenticated = await axios.get<boolean>(
            endpointsList.auth.isAuthenticated(),
          );
          if (isAuthenticated.data) {
            const targetUrl = window.localStorage.getItem(
              IFRAME_TARGET_URL_LOCAL_STORAGE_KEY,
            );
            window.localStorage.removeItem(IFRAME_TARGET_URL_LOCAL_STORAGE_KEY);
            if (targetUrl) {
              window.location.href = targetUrl;
              break;
            } else {
              console.error('No target URL for iframe redirection found');
              break;
            }
          } else await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      },
    },
  });
</script>

<style scoped lang="scss">
  .login-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
